"use client";

import { useCallback, useContext, useEffect } from "react";
import {
    FeedRidContext,
    LiveFeedContext,
    useWebsocketUpdates,
    WebsocketContext,
} from "@finbackoffice/site-core";
import { IClientError } from "@finbackoffice/websocket-client";
import { FeedScopeEnum } from "utils/constants";
import { useSocketStorage } from "hooks";
import { useGetCurrentFeedType } from "./useGetCurrentFeed";

export const useLiveSports = (): void => {
    const feed = useGetCurrentFeedType();
    const { setLive } = useContext(LiveFeedContext);
    const { connected } = useContext(WebsocketContext);
    const { liveRid } = useContext(FeedRidContext);
    const { getSports, getTopLeagues } = useSocketStorage(liveRid);

    const handler = useCallback(
        (response: { rid: string }, error: IClientError) => {
            if (!error) {
                const rid = response.rid;
                const sports = getSports(rid);
                const topLeagues = getTopLeagues(rid);
                setLive({
                    rid,
                    loading: false,
                    sports,
                    topLeagues,
                    totalGames: sports.reduce((acc, s) => acc + s.games_count, 0),
                });
            } else {
                console.error(error);
            }
        },
        [getSports, getTopLeagues, setLive],
    );
    const { subscribe, unsubscribe } = useWebsocketUpdates("live", handler, {
        subscribeByDefault: false,
    });

    useEffect(() => {
        if (feed === FeedScopeEnum.live) {
            subscribe();
        } else {
            unsubscribe();
            setLive({
                rid: "",
                loading: true,
                sports: [],
                totalGames: 0,
                topLeagues: [],
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connected, feed]);

    useEffect(() => {
        return () => {
            if (feed === FeedScopeEnum.live) {
                setLive({
                    rid: "",
                    loading: true,
                    sports: [],
                    totalGames: 0,
                    topLeagues: [],
                });
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
